export default __webpack_public_path__ + "static/media/p1.b8f2ac92.png";